import React, { useState } from 'react'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Col, Collapse, Row } from 'reactstrap'

const ToxicologyTestingPanel = () => {

    const [open1, setOpen1] = useState(false)
    const [open2, setOpen2] = useState(false)
    const [open3, setOpen3] = useState(false)
    const [open4, setOpen4] = useState(false)
    const [open5, setOpen5] = useState(false)
    const [open6, setOpen6] = useState(false)
    const [open7, setOpen7] = useState(false)
    const [open8, setOpen8] = useState(false)
    const [open9, setOpen9] = useState(false)
    const [open10, setOpen10] = useState(false)
    const [open11, setOpen11] = useState(false)
    const [open12, setOpen12] = useState(false)
    const [open13, setOpen13] = useState(false)
    const [open14, setOpen14] = useState(false)

    const handleToggle1 = () => {
        setOpen1(!open1)
        console.log(open1)
    }

    const handleToggle2 = () => {
        setOpen2(!open2)
        console.log(open2)
    }

    const handleToggle3 = () => {
        setOpen3(!open3)
        console.log(open3)
    }

    const handleToggle4 = () => {
        setOpen4(!open4)
        console.log(open4)
    }

    const handleToggle5 = () => {
        setOpen5(!open5)
        console.log(open1)
    }

    const handleToggle6 = () => {
        setOpen6(!open6)
        console.log(open1)
    }

    const handleToggle7 = () => {
        setOpen7(!open7)
        console.log(open2)
    }
    const handleToggle8 = () => {
        setOpen8(!open8)
        console.log(open2)
    }
    const handleToggle9 = () => {
        setOpen9(!open9)
        console.log(open2)
    }
    const handleToggle10 = () => {
        setOpen10(!open10)
        console.log(open2)
    }
    const handleToggle11 = () => {
        setOpen11(!open11)
        console.log(open2)
    }

    const handleToggle12 = () => {
        setOpen12(!open12)
        console.log(open2)
    }

    const handleToggle13 = () => {
        setOpen13(!open13)
        console.log(open2)
    }

    const handleToggle14 = () => {
        setOpen14(!open14)
        console.log(open2)
    }

    return (
        <div id='website-responsive'>
            <div className='bg-img py-md-5 py-4' style={{ backgroundImage: 'url("https://unitedlabcare.com/wp-content/uploads/2023/05/Toxicology-Testing-Middle-bg-v1.webp")', height: '100%', width: '100%' }}>
                <div className=''>
                    <div className=''>
                        <text className='fs-ss-30 text-montserrat fw-700 text-white'>
                            <center>
                                Toxicology Testing Panels
                                <hr className='hr-style my-md-2' style={{ width: '80px', marginTop: '2px', marginBottom: '4px' }} />
                            </center>
                        </text>
                    </div>

                    <div className='py-3 px-md-0 px-2'>
                        <text className='fs-ss-16 text-montserrat text-white fw-600' style={{ letterSpacing: '0.5px' }}>
                            <center>
                                Test results are released directly into your patient software. Our drug panel test detects 15 toxins & over 100 different drugs.
                                <br />
                                Call us for oral tests or urine tests anywhere in Chicago.
                            </center>
                        </text>
                    </div>

                    <div className=''>
                        <Row className=''>
                            <Col sm='12' md='' className=''>
                                <div className=''>
                                  

                                    <section className='faq left-padding6rem00 rightpadding6rem1'>

                                        <div className='container-zk'>

                                            <div className='row pt-md-0 pt-0 pb-4' id="faq-home">

                                                <div className='col-md10 mxauto p-md5 pb-4' style={{ borderRadius: "30px" }}>

                                                    <div className='accordion accordion-flush px-md-0 px-2' id='accordionFlushExample'>

                                                        <div className='accordion-item'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingOne'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseOne' aria-expanded='false' aria-controls='flush-collapseOne'>

                                                                    <span className='fs-ss-16 text-poppins my-2 fw-700 text-zksecondary' style={{ fontWeight: "600" }}>Screen by Immunoassay</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseOne' className='accordion-collapse collapse' aria-labelledby='flush-headingOne' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'><ul className=''>
                                                                        {/* <ul className='fs-ss-16 text-montserrat fw-600'> */}
                                                                        <li className='pb-1'>6 – MAM (Heroin)</li>
                                                                        <li className='pb-1'>Hypertension Cardiac Profile</li>
                                                                        <li className='pb-1'>Thyroid/Obesity</li>
                                                                        <li className='pb-1'>Diabetes Panel</li>
                                                                        <li className='pb-1'>Arthritis/Collagen Rheumatic Diseases</li>
                                                                        <li className='pb-1'>Liver/Alcoholism</li>
                                                                        <li className='pb-1'>Bone Density</li>
                                                                        <li className='pb-1'>Kidney Cystitis</li>
                                                                        <li className='pb-1'>Abdominal Pain/Pancreatitis</li>
                                                                        <li className='pb-1'>Anemia Profile</li>
                                                                        <li className='pb-1'>Ob/Prenatal</li>
                                                                        <li className='pb-1'>Menstrual Disorder</li>
                                                                        <li className='pb-1'>School Physical</li>
                                                                    </ul>
                                                                        {/* </ul> */}
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        {/* <hr /> */}



                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingThree'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseThree' aria-expanded='false' aria-controls='flush-collapseThree'>

                                                                    <span className='fs-ss-16 text-poppins my-2  text-zk-secondary' style={{ fontWeight: "600" }}>

                                                                        Opioids </span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseThree' className='accordion-collapse collapse' aria-labelledby='flush-headingThree' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                                        <li className='pb-1'>Buprenorphine (Buprenex, Butrans)</li>
                                                                        <li className='pb-1'>Codeine (Tyleol #3)
                                                                        </li>
                                                                        <li className='pb-1'>Fentanyl (Fentora, Ourageslc)</li>
                                                                        <li className='pb-1'>Hydrocodone (Vicodin, Norco)
                                                                        </li>
                                                                        <li className='pb-1'>Hydromorphone (Dllaudld)
                                                                        </li>
                                                                        <li className='pb-1'>Meperidine (Demerol)
                                                                        </li>
                                                                        <li className='pb-1'>Methadone
                                                                        </li>
                                                                        <li className='pb-1'>T3U, T4, TSH (1R)</li>
                                                                        <li className='pb-1'>Morphine (MS•Contln)
                                                                        </li>
                                                                        <li className='pb-1'>Naloxone (Suboxone)
                                                                        </li>
                                                                        <li className='pb-1'>Naltrexone (Vlvltrol)
                                                                        </li>
                                                                        <li className='pb-1'>Oxycodone (Oxycontln, Percocet)</li>

                                                                        <li className='pb-1'>Oxymorphone (Opana)
                                                                        </li>

                                                                        <li className='pb-1'>Sufentanil (Sufenta)
                                                                        </li>

                                                                        <li className='pb-1'>Tapentadol (Nucynta)
                                                                        </li>

                                                                        <li className='pb-1'>Tramadol (Ultram)
                                                                        </li>
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>



                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingFour'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFour' aria-expanded='false' aria-controls='flush-collapseFour'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>

                                                                        Benzodiazepines</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseFour' className='accordion-collapse collapse' aria-labelledby='flush-headingFour' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'> <ul className=''>
                                                                        <li className='pb-1'>Alprazolam (Xanax)
                                                                        </li>
                                                                        <li className='pb-1'>Adlnazolam (Deracyn)
                                                                        </li>
                                                                        <li className='pb-1'>Clonazepam (Klonopln)
                                                                        </li>
                                                                        <li className='pb-1'>Diazepam (Valium)
                                                                        </li>
                                                                        <li className='pb-1'>Flunitrazepam (Rohypnol)
                                                                        </li>
                                                                        <li className='pb-1'>Flurazepam</li>
                                                                        <li className='pb-1'>Lorazepam (Atlvan)
                                                                        </li>
                                                                        <li className='pb-1'>Midazolam (Versed, Hynovel, Dormlcum)
                                                                        </li>
                                                                        <li className='pb-1'>Oxazepam (Serax)
                                                                        </li>
                                                                        <li className='pb-1'>Temazepam( Restorll)
                                                                        </li>
                                                                    </ul>  </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingFive'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFive' aria-expanded='false' aria-controls='flush-collapseFive'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>

                                                                        Illicit</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseFive' className='accordion-collapse collapse' aria-labelledby='flush-headingFive' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                                        <li className='pb-1'>6 – MAM (Heroin)
                                                                        </li>
                                                                        <li className='pb-1'>Benzoylecgonine (Cocaine)
                                                                        </li>
                                                                        <li className='pb-1'>PCP</li>
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingSix'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFSix' aria-expanded='false' aria-controls='flush-collapseFSix'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>
                                                                        Amphetamines </span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseFSix' className='accordion-collapse collapse' aria-labelledby='flush-headingSix' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                                        <li className='pb-1'>Amphetamine (Adderall)
                                                                        </li>
                                                                        <li className='pb-1'>Methamphetamine (Desoxyn)</li>
                                                                        <li className='pb-1'>MOEA
                                                                        </li>
                                                                        <li className='pb-1'>MOMA
                                                                        </li>
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>



                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingSeven'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFSeven' aria-expanded='false' aria-controls='flush-collapseFSeven'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>
                                                                        Barbiturates</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseFSeven' className='accordion-collapse collapse' aria-labelledby='flush-headingSeven' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'><li className='pb-1'>Amobarbital

                                                                    </li>
                                                                        <li className='pb-1'>Butobarbital (Butlsol)
                                                                        </li>
                                                                        <li className='pb-1'>Butalbital (Florlnal)

                                                                        </li>
                                                                        <li className='pb-1'>Phenobarbital
                                                                        </li>
                                                                        <li className='pb-1'>Secobarbital
                                                                        </li></span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingEight'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseEight' aria-expanded='false' aria-controls='flush-collapseEight'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>
                                                                        Sedatives </span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseEight' className='accordion-collapse collapse' aria-labelledby='flush-headingEight' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'><li className='pb-1'>Zolpidem (Amblen)


                                                                    </li> </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        {/* <div className='accordion-item pt-'>

                        <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingNone' >

                            <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseNine' aria-expanded='false' aria-controls='flush-collapseNine'>

                                <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>Can blood tests detect multiple STIs/STDs at once? </span>

                            </button>

                        </h2>

                        <div id='flush-collapseNine' className='accordion-collapse collapse' aria-labelledby='flush-headingNone' data-bs-parent='#accordionFlushExample'>

                            <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                <span className='fs-ss-15 text-montserrat fw-600'>Some blood tests can screen for multiple infections simultaneously, providing comprehensive insights. </span>

                            </div>

                        </div>

                    </div> */}

                                                        {/* <div className='accordion-item pt-'>

                        <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingTen'>

                            <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseTen' aria-expanded='false' aria-controls='flush-collapseTen'>

                                <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>When will I get the results of the tests? </span>

                            </button>

                        </h2>

                        <div id='flush-collapseTen' className='accordion-collapse collapse' aria-labelledby='flush-headingTen' data-bs-parent='#accordionFlushExample'>

                            <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                <span className='fs-ss-15 text-montserrat fw-600'>Turnaround time for these tests are between 24-48 hours but your doctor could receive your results in under 24 hours. We can deliver results for blood work in the same day. </span>

                            </div>

                        </div>

                    </div> */}



                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </section>
                                </div>
                            </Col>



                            <Col sm='12' md='' className=''>
                                <div className=''>
                                   
                                    <section className='faq lef-padding6rem1 right-padding6rem00'>

                                        <div className='container-zk'>

                                            <div className='row pt-md-0 pt-0 pb-4' id="faq-home">

                                                <div className='col-md10 mxauto p-md5 pb-4' style={{ borderRadius: "30px" }}>

                                                    <div className='accordion accordion-flush px-md-0 px-2' id='accordionFlushExample'>

                                                        <div className='accordion-item'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingNine'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseNine' aria-expanded='false' aria-controls='flush-collapseNine'>

                                                                    <span className='fs-ss-16 text-poppins my-2 fw-700 text-zksecondary' style={{ fontWeight: "600" }}>Muscle Relaxers</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseNine' className='accordion-collapse collapse' aria-labelledby='flush-headingNine' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'><ul className=''>
                                                                        <li className='pb-1'>Carisoprodol (Soma)
                                                                        </li>
                                                                        <li className='pb-1'>Cyclobenzaprine (Flexerll)
                                                                        </li>
                                                                    </ul> </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        {/* <hr /> */}



                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingTen'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseTen' aria-expanded='false' aria-controls='flush-collapseTen'>

                                                                    <span className='fs-ss-16 text-poppins my-2  text-zk-secondary' style={{ fontWeight: "600" }}>

                                                                        Tricyclic Antidepressants </span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseTen' className='accordion-collapse collapse' aria-labelledby='flush-headingTen' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                                        {/* <ul className=''> */}
                                                                        <ul className='fs-ss-16 text-montserrat fw-600'>
                                                                            <li className='pb-1'>Amitriptyline
                                                                            </li>
                                                                            <li className='pb-1'>Oeslpramlne
                                                                            </li>
                                                                            <li className='pb-1'>Imipramine</li></ul>
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>



                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingEleven'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseEleven' aria-expanded='false' aria-controls='flush-collapseEleven'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>

                                                                        Nicotine</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseEleven' className='accordion-collapse collapse' aria-labelledby='flush-headingEleven' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'> <ul className='fs-ss-16 text-montserrat fw-600'>
                                                                        <li className='pb-1'>Cotinine</li></ul> </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingTwelve'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseTwelve' aria-expanded='false' aria-controls='flush-collapseTwelve'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>

                                                                        Cannabinoid</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseTwelve' className='accordion-collapse collapse' aria-labelledby='flush-headingTwelve' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                                        <ul className='fs-ss-16 text-montserrat fw-600'>
                                                                            <li className='pb-1'>THC</li>
                                                                        </ul>
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headinThirteen'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseThirteen' aria-expanded='false' aria-controls='flush-collapseThirteen'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>Psychiatric (Oral Fluid Only l)</span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseThirteen' className='accordion-collapse collapse' aria-labelledby='flush-headinThirteen' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'>
                                                                        <ul className='fs-ss-16 text-montserrat fw-600'>
                                                                            <li className='pb-1'>Amoxapine (AsendIn,Defanyl)
                                                                            </li>
                                                                            <li className='pb-1'>Aripiprazole (Ablllfy)</li>
                                                                            <li className='pb-1'>Buspirone</li>
                                                                            <li className='pb-1'>Carbamazepine (Tegretol)
                                                                            </li>
                                                                            <li className='pb-1'>Chlordiazepoxide (Librium)
                                                                            </li>
                                                                            <li className='pb-1'>Chlorpromazine
                                                                            </li>
                                                                            <li className='pb-1'>Citalopram (Celexa,Clpramll)
                                                                            </li>
                                                                            <li className='pb-1'>Clomipramine (Anafranll)
                                                                            </li>
                                                                            <li className='pb-1'>Clozapine (Clozarll, FazaClo)
                                                                            </li>
                                                                            <li className='pb-1'>Diphenhydramine (Benadryl)
                                                                            </li>
                                                                            <li className='pb-1'>Duloxetine (Cymbalta)
                                                                            </li>
                                                                            <li className='pb-1'>Fluoxetine (Prozac, Sarafem)
                                                                            </li>
                                                                            <li className='pb-1'>Fluphenazine (Prolixin)
                                                                            </li>
                                                                            <li className='pb-1'>Fluvoxamine (Luvox,Faverln)
                                                                            </li>
                                                                            <li className='pb-1'>Haloperidol (Haldol)
                                                                            </li>
                                                                            <li className='pb-1'>Hydroxybuproplon (Wellbutrin)
                                                                            </li>
                                                                            <li className='pb-1'>Hydroxyzine (Vlstarll, Atarax)
                                                                            </li>
                                                                            <li className='pb-1'>Maprotiline (Deprllept)
                                                                            </li>
                                                                            <li className='pb-1'>Mirtazapine (Remeron)
                                                                            </li>
                                                                            <li className='pb-1'>Olanzapine (Zyprexa)
                                                                            </li>
                                                                            <li className='pb-1'>Paroxetlne (Paxll)
                                                                            </li>
                                                                            <li className='pb-1'>Propranolol (lnderal)
                                                                            </li>
                                                                            <li className='pb-1'>Protriptyline (Vlvactll)
                                                                            </li>
                                                                            <li className='pb-1'>Quetiapine (Seroquel)
                                                                            </li>
                                                                            <li className='pb-1'>Risperidone (Risperdal)
                                                                            </li>
                                                                            <li className='pb-1'>Sertraline (Zoloft)
                                                                            </li>
                                                                            <li className='pb-1'>Thioridazine (Mellarll)
                                                                            </li>
                                                                            <li className='pb-1'>Trazodone (Oleptro)
                                                                            </li>
                                                                            <li className='pb-1'>Triazolam (Halcion)
                                                                            </li>
                                                                            <li className='pb-1'>Trifluoperazine (Eskazlnyl)
                                                                            </li>
                                                                            <li className='pb-1'>Trimipramine (Surmontll)
                                                                            </li>
                                                                            <li className='pb-1'>Venlafaxine (Effexor)
                                                                            </li>
                                                                            <li className='pb-1'>Ziprasidone (Geodon)
                                                                            </li>
                                                                            <li className='pb-1'>Zopllcone (Zimovane)
                                                                            </li>
                                                                        </ul>
                                                                    </span>

                                                                </div>

                                                            </div>

                                                        </div>



                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingFourteen'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFourteen' aria-expanded='false' aria-controls='flush-collapseFourteen'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>
                                                                        Stimulants </span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseFourteen' className='accordion-collapse collapse' aria-labelledby='flush-headingFourteen' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'><ul className='fs-ss-16 text-montserrat fw-600'>
                                                                        <li className='pb-1'>Phentermine (Adlpex-P)</li>
                                                                        <li className='pb-1'>Methylphenidate (Rltalln, Concerta)</li>
                                                                    </ul></span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div className='accordion-item pt-'>

                                                            <h2 className='accordion-header' style={{ borderBottom: '' }} id='flush-headingFifteen'>

                                                                <button style={{ backgroundColor: '#f1f1f1' }} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseFifteen' aria-expanded='false' aria-controls='flush-collapseFifteen'>

                                                                    <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{ fontWeight: "600" }}>
                                                                        Alcohol Metabolites </span>

                                                                </button>

                                                            </h2>

                                                            <div id='flush-collapseFifteen' className='accordion-collapse collapse' aria-labelledby='flush-headingFifteen' data-bs-parent='#accordionFlushExample'>

                                                                <div className='accordion-body' style={{ backgroundColor: '#f1f1f1', borderBottom: '' }}>

                                                                    <span className='fs-ss-15 text-montserrat fw-600'><li className='pb-1'>Ethyl Glucuronide, Ethyl Sulfate</li></span>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        {/* <div className='accordion-item pt-'>

                        <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingNone' >

                            <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseNine' aria-expanded='false' aria-controls='flush-collapseNine'>

                                <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>Can blood tests detect multiple STIs/STDs at once? </span>

                            </button>

                        </h2>

                        <div id='flush-collapseNine' className='accordion-collapse collapse' aria-labelledby='flush-headingNone' data-bs-parent='#accordionFlushExample'>

                            <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                <span className='fs-ss-15 text-montserrat fw-600'>Some blood tests can screen for multiple infections simultaneously, providing comprehensive insights. </span>

                            </div>

                        </div>

                    </div> */}

                                                        {/* <div className='accordion-item pt-'>

                        <h2 className='accordion-header' style={{ borderBottom:''}} id='flush-headingTen'>

                            <button style={{ backgroundColor:'#f1f1f1'}} className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target='#flush-collapseTen' aria-expanded='false' aria-controls='flush-collapseTen'>

                                <span className='fs-ss-16 text-poppins my-2 text-zk-secondary' style={{fontWeight:"600"}}>When will I get the results of the tests? </span>

                            </button>

                        </h2>

                        <div id='flush-collapseTen' className='accordion-collapse collapse' aria-labelledby='flush-headingTen' data-bs-parent='#accordionFlushExample'>

                            <div className='accordion-body' style={{ backgroundColor:'#f1f1f1', borderBottom:''}}>

                                <span className='fs-ss-15 text-montserrat fw-600'>Turnaround time for these tests are between 24-48 hours but your doctor could receive your results in under 24 hours. We can deliver results for blood work in the same day. </span>

                            </div>

                        </div>

                    </div> */}



                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </section>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ToxicologyTestingPanel